var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMachineSettingsIcon = function SvgMachineSettingsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3AACC8",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#machine-settings-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.25 3.476-.468-.108a1.18 1.18 0 0 0-1.415 1.415l.108.47a1.33 1.33 0 0 1-.56 1.408l-.57.38a1.152 1.152 0 0 0 0 1.918l.57.38c.462.308.685.869.56 1.41l-.108.468a1.18 1.18 0 0 0 1.415 1.415l.469-.108a1.33 1.33 0 0 1 1.409.56l.38.57a1.152 1.152 0 0 0 1.917 0l.38-.57a1.33 1.33 0 0 1 1.41-.56l.469.108a1.18 1.18 0 0 0 1.415-1.415l-.108-.469a1.33 1.33 0 0 1 .56-1.409l.57-.38a1.152 1.152 0 0 0 0-1.918l-.57-.38a1.33 1.33 0 0 1-.56-1.409l.108-.469a1.18 1.18 0 0 0-1.415-1.415l-.47.108a1.33 1.33 0 0 1-1.408-.56l-.38-.57a1.152 1.152 0 0 0-1.918 0l-.38.57a1.33 1.33 0 0 1-1.41.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.835 8a1.833 1.833 0 1 1-3.667 0 1.833 1.833 0 0 1 3.667 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "machine-settings-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export { SvgMachineSettingsIcon as ReactComponent };
export default __webpack_public_path__ + "5eb83257cc3349b7078b63f371ae7b62.svg";